/*@flow*/
import nested from 'lib/nested';

export default function isAdmin(): %checks {
  return nested(window, 'CONFIG.ME.id') === 1;
}
